import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: inline-block;
      vertical-align: middle;
    }

    /* ── Button ─────────────────────────────────────────────────────────────── */
    .uwc-tb {
      --_bg:        var(--uwc-togglebtn-bg,         ${t.surface});
      --_border:    var(--uwc-togglebtn-border,      1px solid ${t.borderControl});
      --_color:     var(--uwc-togglebtn-color,       ${t.text});
      --_radius:    var(--uwc-togglebtn-radius,      ${t.radiusMd});
      --_font-size: var(--uwc-togglebtn-font-size,   ${t.fontSizeMd});
      --_height:    var(--uwc-togglebtn-height,      ${t.controlHeightMd});
      --_px:        var(--uwc-togglebtn-padding-x,   0.875rem);
      --_py:        var(--uwc-togglebtn-padding-y,   0);
      --_gap:       var(--uwc-togglebtn-gap,         0.375rem);
      --_active-bg: var(--uwc-togglebtn-active-bg,   var(--uwc-color-primary, ${t.primary}));
      --_active-color: var(--uwc-togglebtn-active-color, ${t.colorWhite});

      position: relative;
      overflow: hidden;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap:            var(--_gap);
      min-height:     var(--_height);
      padding-inline: var(--_px);
      padding-block:  var(--_py);
      font-family:    var(--uwc-font-family, inherit);
      font-size:      var(--_font-size);
      font-weight:    ${t.fontWeightMedium};
      line-height:    1.25;
      white-space:    nowrap;
      cursor:         pointer;
      user-select:    none;
      outline:        none;
      box-sizing:     border-box;
      border:           var(--_border);
      border-radius:    var(--_radius);
      background-color: var(--_bg);
      color:            var(--_color);
      transition:
        background-color ${t.durationBase},
        border-color     ${t.durationBase},
        color            ${t.durationBase},
        box-shadow       ${t.durationBase};
    }

    /* Hidden input */
    input[type="checkbox"] {
      position: absolute;
      inset: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      cursor: pointer;
    }

    .uwc-tb:hover { background-color: ${t.hoverBg}; }
    .uwc-tb:focus-within {
      outline: 2px solid var(--uwc-color-primary, ${t.primary});
      outline-offset: 2px;
    }

    /* ── Checked / on ───────────────────────────────────────────────────────── */
    :host([checked]) .uwc-tb {
      background-color: var(--_active-bg);
      border-color:     var(--_active-bg);
      color:            var(--_active-color);
    }
    :host([checked]) .uwc-tb:hover {
      background-color: color-mix(in oklab, var(--_active-bg) 100%, black 8%);
    }

    /* ── Outline modifier ───────────────────────────────────────────────────── */
    :host([outline]:not([checked])) .uwc-tb {
      --_color: var(--uwc-color-primary, ${t.primary});
      border-color: var(--uwc-color-primary, ${t.primary});
    }

    /* ── Disabled ───────────────────────────────────────────────────────────── */
    :host([disabled]) {
      pointer-events: none;
      opacity: 0.6;
    }

    /* ── Sizes ──────────────────────────────────────────────────────────────── */
    :host([size="small"]) .uwc-tb { font-size: ${t.fontSizeXs}; --_px: 0.625rem; --_py: 0.3125rem; }
    :host([size="large"]) .uwc-tb { font-size: ${t.fontSizeLg}; --_px: 1.125rem; --_py: 0.6875rem; }

    /* ── Icon ───────────────────────────────────────────────────────────────── */
    .uwc-tb__icon {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
    }
    .uwc-tb__label { display: inline-flex; align-items: center; }

    /* ── Ripple ─────────────────────────────────────────────────────────────── */
    @keyframes uwc-tb-ripple {
      from { opacity: 0.2; transform: scale(0);   }
      to   { opacity: 0;   transform: scale(2.5); }
    }
    .uwc-tb-ripple {
      position: absolute;
      border-radius: 50%;
      background: currentColor;
      pointer-events: none;
      animation: uwc-tb-ripple 480ms ease-out forwards;
    }
  `,
];
